export default "__VITE_ASSET__TX_7tB2K__"